/** FGTS × Celcoin. */

import { httpV1 as http } from '@/services/api';

const ALT_API_URL = `${process.env.VUE_APP_ALT_BASE_API_URL || process.env.VUE_APP_BASE_API_URL}/v1`;

export async function consult(params) {
  return http.get('/celcoin/fgts/balance', { params });
}

export async function tryAgain(data) {
  return http.put(`${ALT_API_URL}/celcoin/fgts/credit-operation`, data);
}

export async function verify(params) {
  return http.get('/celcoin/fgts/proposal', { params });
}

export async function cancel(id) {
  return http.delete(`/celcoin/fgts/proposal/${id}`);
}

export async function withdrawalProposal(externalProposalId) {
  return http.post('/celcoin/fgts/proposal/reversal', {
    external_proposal_id: externalProposalId,
  });
}

/* Quitação (PayoffCharges) — CLT e CLT Leilão */
